import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/LegalPage.css";

const PrivacyPolicy = ({ sidebarOpen }) => {
  const navigate = useNavigate();

  return (
    <main className={`legal-container ${sidebarOpen ? "sidebar-open" : ""}`}>
      <article className="legal-card">
        <button type="button" className="legal-back" onClick={() => navigate(-1)}>
          Back
        </button>
        <h1>Privacy Policy</h1>
        <p className="legal-updated">Last updated: May 6, 2026</p>

        <section>
          <h2>Information We Store</h2>
          <p>
            PrepRight stores account details, profile preferences, pantry items, recipes, meal plans, shopping lists,
            activity, achievements, feed posts, and settings you choose to save.
          </p>
        </section>

        <section>
          <h2>How We Use It</h2>
          <p>
            We use your information to run the app, personalize recipes, manage shopping and pantry features, show
            achievements, support account access, and improve the product.
          </p>
        </section>

        <section>
          <h2>Cookies and Local Storage</h2>
          <p>
            The app uses browser storage for login state, settings, cookie consent, and onboarding progress. You can
            clear this data through your browser, though some app features may reset.
          </p>
        </section>

        <section>
          <h2>Password Reset Email</h2>
          <p>
            If you request a password reset, PrepRight creates a temporary reset token and sends a reset link to your
            email when email delivery is configured on the server.
          </p>
        </section>

        <section>
          <h2>Deleting Your Account</h2>
          <p>
            You can delete your profile from Settings. Account data is removed according to the app deletion flow, while
            recipes may be preserved in anonymized form.
          </p>
        </section>
      </article>
    </main>
  );
};

export default PrivacyPolicy;
